var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 0C3.58998 0 0.815979 2.774 0.815979 6.184C0.815979 8.779 2.32698 11.26 3.59398 12.884C4.07598 13.502 6.19798 16 6.99998 16C7.76998 16 9.67998 13.883 10.433 12.918C11.688 11.31 13.184 8.836 13.184 6.185C13.184 2.774 10.41 0 6.99998 0ZM6.99998 8.498C5.72398 8.498 4.68598 7.46 4.68598 6.184C4.68598 4.908 5.72398 3.871 6.99998 3.871C8.27598 3.871 9.31398 4.909 9.31398 6.185C9.31398 7.461 8.27598 8.498 6.99998 8.498Z",
    fill: "#BEEB9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.0a7c76ecb2762ec8cdf8ce656e96b9fa.svg";
export { ForwardRef as ReactComponent };